export const pucPdfs = {
    Arts: {
     
    },
    // Commerce, Science subjects...
  };
  